var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.isExperienceEditor || this.shouldDisplay)?_c('div',{staticClass:"footer"},[_c('sc-placeholder',{attrs:{"name":"jssfootercontent","rendering":_vm.rendering}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }